export default __webpack_public_path__ + "static/eguides-header-04dc2e916bde70d756d7dbcb865be18e.jpg";